<table class="m-table"
       :class="['m--is-skin-' + skin, {'m--is-loading': loading, 'm--is-row-highlighted-on-hover': rowHighlightedOnHover}]"
       cellspacing="0">
    <slot name="header">
        <thead>
            <tr>
                <th v-for="(column, index) in columnsInternal"
                    :style="columnWidth(column)"
                    :class="[{ 'm--is-sortable': column.sortable,
                               'm--is-sorted': isColumnSorted(column),
                               'm--is-text-align-center': isColumnTextAlignCenter(column),
                               'm--is-text-align-left': isColumnTextAlignLeft(column),
                               'm--is-text-align-right': isColumnTextAlignRight(column),
                               'm--is-initial-sort': column.isInitialSort }, column.class]"
                    :key="column.id"
                    @click="sort(column)"
                    scope="col">
                    <div v-if="column.sortable"
                         class="m-table__header-wrap">
                        <div class="m-table__sortable-icon-wrap">
                            <slot :name="'header.' + column.dataProp"
                                  :column="column">
                                <div class="m-table__header-name"
                                     v-html="column.title"></div>
                            </slot>
                            <m-icon-button v-if="column.sortable"
                                           class="m-table__sortable-icon"
                                           :class="[getColumnSortDirectionClass(column)]"
                                           :disabled="loading"
                                           :icon-name="getColumnSortIcon(column)"
                                           skin="bold"
                                           button-size="14px"
                                           icon-size="12px"
                                           :title="i18nSort"
                                           @click.stop="sort(column)" />
                        </div>
                    </div>
                    <slot v-else
                          :name="'header.' + column.dataProp"
                          :column="column">
                        <div class="m-table__header-name"
                             v-html="column.title"></div>
                    </slot>
                </th>
            </tr>
        </thead>
    </slot>
    <slot name="body">
        <tbody>
            <tr class="m-table__placeholder"
                v-if="isEmpty || loading">
                <td class="m-table__placeholder-container"
                    :style="{ position: placeholderPositionType }"
                    colspan="100%">
                    <m-progress v-if="loading"
                                :indeterminate="true"
                                :border-radius="false" />
                    <div class="m-table__placeholder-message"
                         :style="{ width: widthPlaceholder }">
                        <slot name="empty"
                              v-if="isEmpty">
                            <p>{{ i18nEmptyTable }}</p>
                        </slot>
                        <slot name="loading"
                              v-if="loading">
                            <p>{{ i18nLoading }}</p>
                            <p class="m-table__placeholder-precision">{{ i18nPleaseWait }}</p>
                        </slot>
                    </div>
                </td>
            </tr>
            <tr v-else
                v-for="(row, index) in rows"
                :key="index">
                <slot name="row"
                      :data="row">
                    <td v-for="column in columnsInternal"
                        :class="[{ 'm--is-sortable': column.sortable,
                                  'm--is-text-align-center': isColumnTextAlignCenter(column),
                                  'm--is-text-align-left': isColumnTextAlignLeft(column),
                                  'm--is-text-align-right': isColumnTextAlignRight(column) }, column.class]"
                        :key="'body.' + column.id">
                        <slot :name="'body.' + column.dataProp"
                              :data="row">{{ row[column.dataProp] }}</slot>
                    </td>
                </slot>
            </tr>
        </tbody>
    </slot>

    <tfoot v-if="$slots.footer">
        <tr>
            <slot name="footer"></slot>
        </tr>
    </tfoot>
</table>
